import React from 'react';

import { IHome } from '@/modules/home/types';
import { Typography } from '@/shared/components/atoms';
import Tabs from '@/shared/components/atoms/Tabs';

const WorkforceHeader: React.FC<IHome.IWorkforceHeaderProps> = ({
  tabsList,
  title,
  icon,
  tabQueryIndicator,
  defaultValue,
}) => {
  return (
    <div className='sticky flex items-center justify-between gap-8 px-16 pt-16'>
      <div className='flex items-center gap-2'>
        <span className='text-24'>{icon}</span>
        <Typography weight='bold' variant='body1' className='text-wrap w-fit'>
          {title}
        </Typography>
      </div>
      <Tabs
        activeClassName='text-primary-400 !bg-outline-default font-bold'
        getLabel={(item) => item?.label}
        getValue={(item) => item?.key}
        tabsList={tabsList}
        variant='connected'
        defaultValue={defaultValue}
        tabQueryIndicator={tabQueryIndicator}
        linkClassName='px-12 py-6'
      />
    </div>
  );
};

export { WorkforceHeader };
